export default function () {
  const videos = document.querySelectorAll('video[data-lazy-video]');

  function addVideo(videoItem) {
    for (let i = 0; i < videoItem.length; i++) {
      const video = videoItem[i];
      const videoSrc = video.getAttribute('data-src');
      const videoMimeType = video.getAttribute('data-mime-type');
      const videoPosteUrl = video.getAttribute('data-poster');

      const newElement = document.createElement('source');

      newElement.src = videoSrc;
      newElement.type = videoMimeType;

      const parentElement = videoItem[i];

      parentElement.appendChild(newElement);
      parentElement.poster = videoPosteUrl;
    }
  }

  addVideo(videos);
}
